import BaseError from './BaseError'

export default class WebError extends BaseError {}